import React, { ReactNode } from "react";
import { Stack, Button } from "@mui/material";
import { EquipmentFormMode } from "../../types";

interface Props {
  disabled?: boolean;
  isLoading?: boolean;
  onSubmit: VoidFunction;
  onCancel: VoidFunction;
  mode: EquipmentFormMode;
  onDeleteEquipment: VoidFunction;
}

export const FormActions = ({
  mode,
  onCancel,
  onSubmit,
  disabled = false,
  isLoading = false,
  onDeleteEquipment,
}: Props) => {
  const additionalActionsByMode: Record<EquipmentFormMode, ReactNode> = {
    [EquipmentFormMode.Create]: null,
    [EquipmentFormMode.Update]: (
      <Button disabled={disabled} loading={isLoading} onClick={onDeleteEquipment} variant="outlined" color="error">
        Remove
      </Button>
    ),
  };

  return (
    <Stack direction="row" gap="0.5rem" justifyContent="flex-end">
      <Button loading={isLoading} onClick={onCancel}>
        Cancel
      </Button>

      {additionalActionsByMode[mode]}

      <Button disabled={disabled} loading={isLoading} onClick={onSubmit} variant="contained">
        {EquipmentFormMode.Create === mode ? "Create" : "Update"}
      </Button>
    </Stack>
  );
};
